import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'formatPrice',
    standalone: true,
})
export class FormatPricePipe implements PipeTransform {
  constructor() {}

  transform(value: number, devise: string, extraDecimals: number = 0): string {
    const baseValue = value / 100;
    let stringValue: string = baseValue.toFixed(2).toString();

    if (!!extraDecimals) {
      if (!stringValue.includes('.')) {
        stringValue += '.';
      }
      stringValue += '0'.repeat(extraDecimals);
    }

    if (devise == 'eur') {
      return stringValue.replace('.', ',') + '€';
    }

    return '$' + stringValue;
  }
}
